module.exports = __webpack_public_path__ + "img/DrMuhsin.60344f3b.jpg";